const LAST_AUTH_PROVIDER_LS = 'last-auth-provider'

const SOCIAL_AUTH_PROVIDERS = ['google', 'facebook', 'apple']

export const setLastAuthProvider = (authMethod: string) => {
	localStorage.setItem(LAST_AUTH_PROVIDER_LS, authMethod)
}

export const getIsSocialAuthenticated = () =>
	SOCIAL_AUTH_PROVIDERS.includes(
		localStorage.getItem(LAST_AUTH_PROVIDER_LS) ?? '',
	)
